
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.364 2.5a2.391 2.391 0 012.386 2.386v9.546a2.391 2.391 0 01-2.386 2.386H3.636a2.391 2.391 0 01-2.386-2.386V4.886A2.391 2.391 0 013.636 2.5zm.795 3.914l-6.703 4.692a.795.795 0 01-.912 0L2.84 6.414v8.018a.8.8 0 00.796.795h12.728a.8.8 0 00.795-.795zm-.795-2.323H3.636a.8.8 0 00-.71.44L10 9.484l7.074-4.953a.8.8 0 00-.71-.44z"}})])
          )
        }
      }
    